import 'css/global/index.scss';
import './js/gateway/general/GatewayContent.scss';
import './js/gateway/general/LinksFooter.scss';
import './js/global/ui/LoadingSpinner.scss';

import { App } from 'antd';
import { AppRoot } from './App';
import { appStore } from '@app';
import { createRoot } from 'react-dom/client';
import { DefaultTheme } from '@ui/themes';
import { ErrorBoundary } from '@ui/general';
import { getJWTToken } from '@sonar-software/sonar-ts-lib';
import { Provider } from 'react-redux';
import React from 'react';
import { updateAuth } from './js/global/redux/application/auth/actions';

const root = createRoot(document.getElementById('root') as HTMLElement);

const initialToken = getJWTToken();

if (initialToken) {
	appStore.dispatch(updateAuth(initialToken));
}

root.render(
	<Provider store={ appStore }>
		<ErrorBoundary>
			<DefaultTheme>
				<App notification={ { placement: 'bottomRight' } }>
					<AppRoot />
				</App>
			</DefaultTheme>
		</ErrorBoundary>
	</Provider>
);
